import { profilePhoto } from "@/assets";

export default function About() {
  return (
    <div className="flex flex-col pt-10">
      {/* Page Header */}
      <section className="pt-20 pb-16 bg-background border-b border-border/40">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-foreground leading-[1.1] tracking-tight mb-8">
            About.
          </h1>
          <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl text-balance italic font-serif">
            "Emerging analyst building through real projects, disciplined study, and applied work."
          </p>
        </div>
      </section>

      {/* Main Bio Section */}
      <section className="py-24 bg-background">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">
            
            {/* Image Column */}
            <div className="lg:col-span-4">
              <div className="aspect-[3/4] overflow-hidden rounded-sm shadow-lg sticky top-28">
                <img
                  src={profilePhoto}
                  alt="Shateara Davis"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>

            {/* Bio Column */}
            <div className="lg:col-span-8 space-y-8">
              <h2 className="text-3xl md:text-4xl font-serif text-foreground leading-tight">
                Shateara Davis
              </h2>
              <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
                <p>
                  I'm Shateara Davis, a multidisciplinary professional working across data analysis, conversion-focused website design, app development, and writing. My work is grounded in clarity, strategic thinking, and a commitment to building digital experiences that are both useful and thoughtfully executed.
                </p>
                <p>
                  I am particularly interested in the intersection of structure, insight, and human-centered design. Whether working with data, shaping a digital interface, or developing a product concept, I approach the work with care, curiosity, and a strong attention to detail.
                </p>
                <p>
                  As I continue developing my foundation in data analysis, I am building practical experience through active projects and ongoing study. This work complements my broader interest in creating digital systems that support better decisions, stronger communication, and more intentional user experiences.
                </p>
                <p>
                  Alongside that work, I design websites focused on trust, clarity, and conversion, and I build applications informed by lived experience, research, and product discipline. I am drawn to work that solves real problems with precision while remaining grounded in the people it is meant to serve.
                </p>
                <p>
                  Writing remains an essential part of how I think, refine ideas, and document growth. Through my blog and other platforms, I explore digital building, learning in public, and the evolving relationship between technology and human need.
                </p>
                <p>
                  My goal is to build work that reflects both rigor and intention; work that is professionally sound, strategically clear, and meaningful in practice.
                </p>
              </div>

              {/* Disciplines */}
              <div className="pt-8 border-t border-border/40 grid grid-cols-2 gap-8">
                <div>
                  <h3 className="text-xs font-semibold uppercase tracking-widest text-primary mb-4">Disciplines</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li>Data Analysis</li>
                    <li>Website Design</li>
                    <li>App Development</li>
                    <li>Writing & Research</li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-xs font-semibold uppercase tracking-widest text-primary mb-4">Who I work with</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li>Early Stage Builders</li>
                    <li>Small Businesses</li>
                    <li>Mission Driven Brands</li>
                    <li>Non-profits</li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-plum text-white py-24 border-t-4 border-primary">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl text-center space-y-8">
          <h2 className="text-4xl md:text-5xl font-serif text-white leading-tight">
            Ready to work together?
          </h2>
          <p className="text-lg text-white/80 leading-relaxed font-light">
            Let's talk about your project, your data, or your next idea.
          </p>
          <div className="pt-4">
            <a href="https://calendly.com/shateara-davis-proton" target="_blank" rel="noopener noreferrer">
              <button className="bg-secondary hover:bg-secondary/90 text-white rounded-none px-10 py-5 text-sm uppercase tracking-wider font-semibold transition-colors">
                Book a Call
              </button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
